const DESKTOP_MIN_WIDTH = 1200
export const TABLET_MAX_WIDTH = DESKTOP_MIN_WIDTH - 1
const TABLET_MIN_WIDTH = 768
export const MOBILE_MAX_WIDTH = TABLET_MIN_WIDTH - 1

export const DESKTOP_SCREENSIZE = `(min-width: ${DESKTOP_MIN_WIDTH}px)`
export const TABLET_SCREENSIZE = `(max-width: ${TABLET_MAX_WIDTH}px)`
export const MOBILE_SCREENSIZE = `(max-width: ${MOBILE_MAX_WIDTH}px)`

// Breakpoints for User portal
const USER_LARGE_DESKTOP_MIN_WIDTH = 1440
const USER_DESKTOP_MAX_WIDTH = USER_LARGE_DESKTOP_MIN_WIDTH - 1
const USER_SMALL_DESKTOP_MAX_WIDTH = 1024
const USER_DESKTOP_MIN_WIDTH = 950
export const USER_TABLET_MAX_WIDTH = USER_DESKTOP_MIN_WIDTH - 1

export const USER_LARGE_DESKTOP_SCREENSIZE = `(min-width: ${USER_LARGE_DESKTOP_MIN_WIDTH}px)`
export const USER_DESKTOP_SCREENSIZE = `(max-width: ${USER_DESKTOP_MAX_WIDTH}px)`
export const USER_SMALL_DESKTOP_SCREENSIZE = `(max-width: ${USER_SMALL_DESKTOP_MAX_WIDTH}px)`
export const USER_TABLET_SCREENSIZE = `(max-width: ${USER_TABLET_MAX_WIDTH}px)`

// Custom breakpoints
const CALENDLY_DESKTOP_MIN_WIDTH = 1067
const CALENDLY_MOBILE_MIN_WIDTH = 685
export const CALENDLY_DESKTOP_SCREENSIZE = `(max-width: ${CALENDLY_DESKTOP_MIN_WIDTH}px)`
export const CALENDLY_MOBILE_SCREENSIZE = `(max-width: ${CALENDLY_MOBILE_MIN_WIDTH}px)`
